// @ts-nocheck
/* eslint-disable camelcase */
import { resultTypeToAffix } from "~/util/search";
import { CONFIG } from "~/config";
import { linkToNewWindow } from "~/util/userweb";
import { _ } from "~/i18n";
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import { store } from "~/state/store";
import { getIcon } from "~/util/providers/poiagg";
import { TWEAKS_ID } from "~/util/constants";

// obj = null klice se smazou
Mapy.Util.analyticsSearchSelection = (obj = {}, poiData = {}, iconTypeData) => {
	const searchComp = Mapy.getComponent("search");
	const results = Mapy.getComponent("search").getResults();
	const { longitude, latitude, zoom } = store.getState().map;
	const queryType = Mapy.getComponent("search").getQueryType();
	const logObj = {
		query: (searchComp.getState().q || "").trim().toLowerCase(),
		search_type: "search", // [search, suggestion, fixed_suggestion, searchmap, suggestionmap]
		result_type: iconTypeData?.resultType || "poi", // [home, work, poi, booking, paid_poi, category, favourite_poi, history_poi, local_history_poi, local_history_category, location_pick, route, history_query, history_category, local_history_query, destination]
		index: -1, // 1..n
		connectivity_source: "online", // pro web konstanta
		search_center: `${longitude},${latitude}`,
		search_purpose: "search", // [search,route_planner,home,work]
		poi_id: poiData.id || 0,
		poi_title: (poiData?.mmtype === "zero_suggest" ? poiData.phrase : poiData.title || "").trim(),
		poi_source: poiData.source || "",
		name: "",
		qaction: "",
		query_var: "",
		results: results && results.length ? results.slice(0, 10).map(item => `${item.source}_${item.id}${resultTypeToAffix(item.resultType, item.mmsource)}`) : "",
		target: "detail", // [detail|route|search]
		zoom,
		query_type: queryType,
		...obj,
	};

	// byly zadana data pro icon type
	if (iconTypeData) {
		let result_type = "";

		if (iconTypeData.mmsource) {
			switch (iconTypeData.mmsource) {
				case "osm":
				case "firm":
					if ((iconTypeData.source === "osm" || iconTypeData.source === "firm") && !!(iconTypeData.extend && iconTypeData.extend.poi && iconTypeData.extend.poi.booking)) {
						result_type = "booking";
					} else if (iconTypeData.source === "firm" && iconTypeData.extendedData && iconTypeData.extendedData.paid) {
						result_type = "paid_poi";
					}
					break;
				case "poiC":
					result_type = "category";
					break;
				default:
					break;
			}
		}

		// icon type
		if (!result_type && iconTypeData.iconType) {
			switch (iconTypeData.iconType) {
				case "home":
					result_type = "home";
					break;
				case "work":
					result_type = "work";
					break;
				case "favorite":
					result_type = "favourite_poi";
					break;
				case "destination":
					result_type = "destination";
					break;
				default:
					break;
			}
		}


		// ulozime
		if (result_type) {
			logObj.result_type = result_type;
		}
	}

	if (["history_category", "history_query", "category", "query_top", "query_r"].indexOf(logObj.result_type) && !logObj.name && poiData.title) {
		logObj.name = poiData.title;
	}

	// upravy dat
	Object.keys(logObj).forEach(key => {
		const value = logObj[key];

		// smazeme: null klice, prazdne stringy, prazdne id poie, index mensi jak 1
		if (value === null || value === "" || (key === "poi_id" && value === 0) || (key === "index" && value < 1)) {
			delete logObj[key];
		}
	});

	// vlastni log
	Mapy.getComponent("logger").log("search_selection", logObj);
};

/**
 * Pouzije event nad <a> linkem, pokud se jedna o klik ctrl+levy cudl nebo prostredni tlacitko,
 * tak vraci true a otevre odkaz "href" v novem okne.
 *
 * @param  {Event} event
 * @returns {Boolean}
 */
Mapy.Util.linkToNewWindow = event => linkToNewWindow(event);

/**
 * Ziskani src k obrazku pro panoramu detail - pano compose.
 * allowedKeys - povolene klice, max 1500x1500px
 *
 * @param  {Object} conf Konfigurace
 * @returns {String}
 */
Mapy.Util.panoCompose = conf => {
	const MAX_SIZE = 1500;
	const allowedKeys = ["width", "height", "pid", "fov", "pitch", "yaw"];
	const params = [];

	// projdeme pouze podporovane klice
	allowedKeys.forEach(key => {
		if (key in conf) {
			let value = conf[key];
			let param = key;

			if (key === "width") {
				param = "w";
				value = Math.min(MAX_SIZE, value);
			} else if (key === "height") {
				param = "h";
				value = Math.min(MAX_SIZE, value);
			}

			params.push(`${param}=${value}`);
		}
	});

	return `${CONFIG.panoCompose}${params.length ? `?${params.join("&")}` : ""}`;
};

/**
 * Otevře uživatelskou gotogalerii na zálkadě ID autora fotografií
 * @param {string} userPublicId Id autora fotek
 */
Mapy.Util.openPhotogallery = userPublicId => {
	if (Mapy.getComponent("gallery").isActive()) {
		const galleryData = Mapy.getComponent("gallery").getData();

		if (galleryData.source !== "author" || galleryData.id !== userPublicId) {
			Mapy.getComponent("gallery").close();
		}
	}
	Mapy.getComponent("gallery").activate().setData({
		source: "author",
		id: userPublicId,
	});
};

Mapy.Util.getTweaks = (page = 1) => new Promise((resolve, reject) => {
	const params = TWEAKS_ID[Userweb.defaultLang];
	const id = params.tagID;

	if (id) {
		const URL = `/vychytavky?tags=${id}&per_page=20&page=${page}&_fields=tags,id,date,title,content,link,_links&_embed`;
		const request = new XMLHttpRequest();

		request.addEventListener("load", event => {
			const status = event.target.status;
			const data = event.target.responseText;

			if (status >= 200 && status < 300) {
				const items = JSON.parse(data || "[]");
				const result = items.filter(item => item.tags.indexOf(params.shortInfo) !== -1);

				resolve(result);
			} else {
				reject();
			}
		});
		request.addEventListener("error", () => {
			reject();
		});
		request.open("GET", URL);
		request.send();
	} else {
		reject();
	}
});

/**
 * Vytvoří promisi, kterou lze vyresovit mimo její kód
 * @return {Promise}
 */
Mapy.Util.createPrintPromise = () => {
	let res = () => {};
	let rej = () => {};

	const promise = new Promise((resolve, reject) => {
		res = resolve;
		rej = reject;
	});

	promise.resolve = res;
	promise.reject = rej;

	return promise;
};

Mapy.Util.getShortLink = (function shortURL() {
	const cache = [];
	const createErrorAlert = () => {
		Mapy.getComponent("popup").createAlert(_("action.share.mapLink.error"), "mapLinkError");
	};

	const request = (url = window.location.href) => {
		// odstranime box
		let prepareUrl = url.replace("&box=1", "").replace("box=1&", "").replace("box=1", "");
		const found = cache.filter(item => item.url === prepareUrl);

		if (found.length) {
			return found[0].promise;
		}

		if (prepareUrl.indexOf("/letecka?") > -1) {
			const map = store.getState().map;

			prepareUrl += map.ophotoTimeline ? `&otmln=${map.ophotoTimeline}` : "";
		}

		const promise = new Promise((resolve, reject) => {
			Mapy.Util.request(`${CONFIG.requestUrl}/sm/short`, {
				method: "POST",
				json: {
					url: prepareUrl,
				},
				type: "json",
			}).promise.then(data => {
				resolve({
					url: `${location.origin}/s/${data.data.id}`,
					id: data.data.id,
				});
			}, error => {
				createErrorAlert(error);
				reject(error);
			});
		});

		cache.push({ prepareUrl, promise });

		return promise;
	};

	return request;
})();

/**
 * Z elementu vytáhne logovací parametry a zaloguje
 * @param {HTMLElement} element elements logovacímí parametry
 */
Mapy.Util.logFromElement = element => {
	const dataset = element.dataset;

	if ("logAction" in dataset) {
		const logData = {};
		const action = dataset.logAction;
		const keys = Object.keys(dataset);

		keys.forEach(key => {
			if (key !== "logAction" && key.startsWith("log")) {
				const editKey = key.substring(3).toLowerCase();

				logData[editKey] = dataset[key];
			}
		});
		Mapy.getComponent("logger").log(action, logData);
	}
};

Mapy.Util.createBigOldBrowserInfo = webglTest => {
	let code = "";
	let showSbrowser = true;

	if (webglTest) {
		const webglState = Mapy.getWebglState();

		showSbrowser = webglState === 0 ? !Mapy.Util.isSznBrowser() : false;
	}

	if (showSbrowser) {
		code = `<h3>${_("bigOldBrowser.title")}</h3>
			<img src="/img/sbrowser.png" alt="sBrowser" title="sBrowser">
			<p>${_("bigOldBrowser.description")}</p>
			<a href="https://www.seznam.cz/aplikace" target="_blank">${_("bigOldBrowser.button")}</a>`;
	} else {
		code = `<h3>${_("bigOldBrowser.webgl.title")}</h3>
			<p>${_("bigOldBrowser.webgl.description")}</p>
			<a href="${_("bigOldBrowser.webgl.linkUrl")}" target="_blank">${_("bigOldBrowser.webgl.link")}</a>`;
	}

	return Mapy.Util.node("div", { className: "no-supported", innerHTML: code });
};

Mapy.Util.openInNewWindow = fromButton => {
	const history = Mapy.getComponent("history");
	const state = JSON.parse(JSON.stringify(history.state));

	// pokud chybi active, jde o hledani (treba i prazdne), a pokud chybi source, tak pres nej neni ani detail, ktery by souradnice dodal, takze je zachovame
	if ("active" in state || "source" in state) {
		delete state.x;
		delete state.y;
		delete state.z;
	}

	delete state.frame;
	delete state.active;
	delete state.view;
	delete state.searchOrigin;

	if (CONFIG.inFrame) {
		delete state.om;
		delete state.ol;

		iframeAnalyticsLog({
			type: "click-back",
			referrer: document.referrer,
			form: fromButton ? "button" : "other",
		});
	}

	if (CONFIG.inFrame && state.source && state.id) {
		delete state.q;
		delete state.ds;
	}

	window.open(`${CONFIG.mapyURL}${history.serialize(state).replace(`/${CONFIG.defaultLang}`, "")}`);
};

Mapy.Util.getMapset = name => {
	if (name) {
		const mapsets = CONFIG.mapsets;

		for (let index = 0, max = mapsets.length; index < max; index++) {
			const mapset = mapsets[index];

			if ((mapset.base === name && !mapset.hidden) || mapset.seo === name) {
				return mapset;
			}
		}
	}

	return null;
};

Mapy.Util.getImageData = (data, paid) => {
	const image = data.media && data.media.urls ? data.media.urls["1x1"] : null;
	const favicon = data.icon ? data.icon["1"] : null;
	const output = {
		icon: false,
		booking: "",
		url: "",
		url2x: "",
		small: true,
		universal: false,
		favicon: false,
	};
	const extend = data.extend || {};

	// pro booking
	if (extend.poi && extend.poi.booking && extend.poi.photos && extend.poi.photos.length) {
		const photos = extend.poi.photos;
		const main = photos.filter(item => item.main_photo);
		let best = "";

		if (main.length) {
			best = main[0];
		} else {
			best = photos[0];
		}

		output.booking = best.url_max300;
	} else if (image || favicon) {
		if (
			// velka ikona - placena firma
			paid
			// musi mit typename a adresu (bud jeden typ nebo druhy)
			&& (data.typeName && ((extend.address && !data.multiTitle) || (data.multiTitle && data.multiTitle.length >= 2)))
		) {
			output.small = false;
		}

		if (image) {
			output.url2x = Mapy.CDN.setSize(image, output.small ? Mapy.CDN.SIZE_160_104 : Mapy.CDN.SIZE_160_160);
		} else {
			output.url2x = "2" in data.icon ? data.icon["2"] : favicon;
			output.favicon = true;
		}

		if (data.iconSize && !image && data.icon[data.iconSize.toString()]) {
			output.url = data.icon[data.iconSize.toString()];
			output.icon = true;
			output.favicon = false;
		} else {
			output.url = image ? Mapy.CDN.setSize(image, output.small ? Mapy.CDN.SIZE_80_52 : Mapy.CDN.SIZE_80_80) : favicon;
		}
	} else {
		if (!getIcon(data.typeId, { universal: false })) {
			output.universal = true;
		}
		output.url = getIcon(data.typeId, { scale: 2, universal: true });
		output.url2x = getIcon(data.typeId, { scale: 3, universal: true });
		output.icon = true;
	}

	return output;
};
